import BaseUIStoreSettingBillView from 'xui/modules/print/BaseUIStoreSettingBillView'

export default class StoreSettingBillView extends BaseUIStoreSettingBillView {
  static displayName = 'StoreSettingBillView'

  static navigationOptions = {
    header: null,
  }
}
